<div class="board-column">

	<div class="column-header">
		<div class="column-title">
			Mentions
		</div>
	</div>

	<ng-container *ngIf="loadingg">
		<lib-progress-spinner></lib-progress-spinner>
	</ng-container>

	<div class="tasks-container" *ngIf="!loadingg">
		<app-notification *ngFor="let notification of notifications" [userNfs]="notification"></app-notification>

		<div class="no-nfs-block" *ngIf="notifications.length === 0">
			No Mentions
		</div>
	</div>
</div>